import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiMail, FiArrowRight, FiInstagram, FiFacebook } = FiIcons;

const Kontakt = () => {
  const email = "info@trust-franken.de";
  const headerImage = "https://grafiken.trust-franken.de/HP/4646.jpg";
  const logoUrl = "https://grafiken.trust-franken.de/HP/Kreuz.png";

  return (
    <div className="min-h-screen bg-black text-white overflow-x-hidden">
      {/* Hero Header Section */}
      <section className="relative h-[60vh] flex items-end overflow-hidden">
        <motion.img 
          initial={{ scale: 1.2 }}
          animate={{ scale: 1 }}
          transition={{ duration: 1.5 }}
          src={headerImage} 
          alt="Contact Header" 
          className="absolute inset-0 w-full h-full object-cover opacity-60"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent" />
        
        <div className="relative z-10 w-full max-w-7xl mx-auto px-6 pb-16">
          <div className="flex flex-col-reverse md:flex-row items-center md:items-end justify-between gap-10">
            <motion.div 
              initial={{ opacity: 0, x: -100 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 1 }}
              className="text-center md:text-left"
            >
              <h1 className="text-6xl md:text-9xl font-black uppercase tracking-tighter leading-none">
                Kontakt
              </h1>
              <motion.div 
                initial={{ width: 0 }}
                animate={{ width: "100%" }}
                transition={{ delay: 1, duration: 1 }}
                className="h-2 bg-white mt-4" 
              />
            </motion.div>

            <motion.img 
              initial={{ opacity: 0, scale: 0, rotate: 180 }}
              animate={{ opacity: 1, scale: 1, rotate: 0, y: [0, -20, 0] }}
              transition={{ 
                duration: 1.5,
                y: { duration: 4, repeat: Infinity, ease: "easeInOut" }
              }}
              whileHover={{ scale: 1.1, rotate: -10 }}
              src={logoUrl} 
              alt="Trust MC Logo" 
              className="h-40 md:h-64 w-auto drop-shadow-[0_0_50px_rgba(255,255,255,0.2)]"
            />
          </div>
        </div>
      </section>

      <section className="py-32 px-6">
        <div className="max-w-4xl mx-auto">
          <motion.div 
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-center mb-24"
          >
            <p className="text-2xl md:text-4xl text-gray-400 font-light leading-relaxed">
              Hast du Fragen zum Club, unseren Events oder möchtest uns einfach eine Nachricht zukommen lassen? 
              <span className="text-white block mt-4 font-bold uppercase">Wir freuen uns auf den Austausch.</span>
            </p>
          </motion.div>

          <motion.div 
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            className="relative"
          >
            <div className="absolute -inset-1 bg-gradient-to-r from-white/20 to-transparent rounded-[3rem] blur-xl" />
            <div className="relative bg-gray-900/40 backdrop-blur-3xl border border-white/10 rounded-[3rem] p-12 md:p-20 text-center hover:border-white/30 transition-all duration-700 shadow-2xl overflow-hidden group">
              
              {/* Animated Background Elements */}
              <motion.div 
                animate={{ rotate: 360 }}
                transition={{ repeat: Infinity, duration: 20, ease: "linear" }}
                className="absolute -top-24 -right-24 w-64 h-64 bg-white/5 rounded-full blur-3xl pointer-events-none"
              />

              <motion.div 
                whileHover={{ rotate: [0, -10, 10, 0], scale: 1.1 }}
                className="inline-flex items-center justify-center w-28 h-28 bg-white text-black rounded-3xl mb-12 shadow-[0_20px_40px_rgba(255,255,255,0.1)] cursor-pointer"
              >
                <SafeIcon icon={FiMail} className="text-5xl" />
              </motion.div>

              <h2 className="text-4xl md:text-5xl font-black uppercase mb-8 group-hover:scale-105 transition-transform duration-500">Direkter Draht</h2>
              <p className="text-xl text-gray-400 mb-12 max-w-md mx-auto leading-relaxed">
                Klicke auf den Button unten, um dein E-Mail-Programm zu öffnen.
              </p>

              <div className="max-w-sm mx-auto">
                <motion.a 
                  whileHover={{ scale: 1.05, x: 10 }}
                  whileTap={{ scale: 0.95 }}
                  href={`mailto:${email}`} 
                  className="group relative flex items-center justify-center gap-4 w-full bg-white text-black py-6 rounded-2xl font-black uppercase tracking-[0.2em] hover:bg-gray-200 transition-all shadow-[0_15px_30px_rgba(0,0,0,0.4)]"
                >
                  <span>Nachricht senden</span>
                  <SafeIcon icon={FiArrowRight} className="text-2xl transition-transform group-hover:translate-x-2" />
                </motion.a>
              </div>

              <div className="mt-20 flex justify-center gap-10">
                {[FiInstagram, FiFacebook].map((Icon, i) => (
                  <motion.div
                    key={i}
                    whileHover={{ y: -10, color: '#ffffff' }}
                    className="text-3xl text-gray-600 cursor-pointer transition-colors"
                  >
                    <SafeIcon icon={Icon} />
                  </motion.div>
                ))}
              </div>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default Kontakt;